/**
 * @file Discover Album Folder view.
 */

import React from 'react';

import DiscoverAlbumFolderContainer from '../../containers/discover/DiscoverAlbumFolderContainer';

const DiscoverAlbumFolderView = () => <DiscoverAlbumFolderContainer />;

export default DiscoverAlbumFolderView;
